import moment from 'moment';
import ReactPixel from 'react-facebook-pixel';

class FbPixelService {
	initIfIdIsSet(pixelId) {
		try {
			const fbOptions = {
				autoConfig: true,
				debug: false,
			};

			if (pixelId) {
				ReactPixel.init(pixelId, {}, fbOptions);
				ReactPixel.pageView();
			}
		} catch (error) {
			console.warn('Error occured in initIfIdIsSet: ', error);
		}
	}

	trackPurchaseOrCheckout(shoppingcart, fbEventType) {
		try {
			if (!shoppingcart.events || !shoppingcart.events.length) {
				console.warn('Tried to track empty shoppingcart.');
				return;
			}

			const scEvent = shoppingcart.events[0];
			const eventTitleDate = `${scEvent.event} - ${moment(scEvent.eventBegin).format('DD.MM.YYYY HH:mm')}`;

			const value = shoppingcart.events
				.flatMap(event => event.displayTickets)
				.map(ticket => ticket.subTotal.money.value || 0)
				.reduce((acc, curr) => acc + curr, 0);

			const data = {
				content_name: eventTitleDate,
				currency: 'EUR',
				value,
			};

			ReactPixel.track(fbEventType, data);
		} catch (error) {
			console.warn('Error occured in trackPurchaseOrCheckout: ', error);
		}
	}
}

const fbPixelService = new FbPixelService();
export default fbPixelService;
